<template>
  <div class="conteudo-container">
    <div class="conteudo-card">
      <div class="logo-area">
        <img src="@/assets/images/logo-branco.svg" alt="OligoCheck" class="logo" />
      </div>

      <div class="conteudo-body">
        <h1 class="headline">
          Descubra como revolucionar<br>
          <span class="destaque">sua saúde hoje</span>
        </h1>
        
        <div class="divisor"></div>
        
        <div class="video-wrapper">
          <iframe 
            width="100%" 
            height="100%" 
            src="https://www.youtube.com/embed/yBVKrDSyCzs?autoplay=0&controls=1&rel=0" 
            title="YouTube video player" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen
          ></iframe>
        </div>

        <div class="area-botao">
          <transition name="fade-slide">
            <button 
              v-if="mostrarBotao" 
              class="botao-acao azul" 
              @click="acaoBotao"
            >
              <span>QUERO ACESSAR AGORA</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </button>
          </transition>
          
          <p v-if="!mostrarBotao" class="loading-text">
            Aguarde, o conteúdo será liberado em instantes...
          </p>
        </div>

        <div class="footer-seguranca">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          <span>Conteúdo Exclusivo & Seguro</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const mostrarBotao = ref(false)
const TEMPO_EM_SEGUNDOS = 10 // ALTERE AQUI O TEMPO (Ex: 600 para 10 min)
let timer = null

onMounted(() => {
  timer = setTimeout(() => {
    mostrarBotao.value = true
  }, TEMPO_EM_SEGUNDOS * 1000)
})

onUnmounted(() => {
  if (timer) clearTimeout(timer)
})

const acaoBotao = () => {
  // Ação ao clicar no botão
  console.log('Botão clicado!')
  // Exemplo: window.location.href = 'https://checkout...'
}
</script>

<style scoped>
/* 
  Reutilizando a estrutura visual do PagamentoLink.vue 
  para consistência total de design.
*/

.conteudo-container {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--cor-escuro-1);
  background-image: 
    radial-gradient(circle at 50% 0%, rgba(20, 203, 240, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 100% 100%, rgba(1, 61, 126, 0.1) 0%, transparent 50%);
  padding: 40px 20px;
  font-family: var(--regular);
}

.conteudo-card {
  width: 100%;
  max-width: 800px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 32px;
  padding: 48px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 32px 64px -12px rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.8s ease-out;
}

.logo-area {
  margin-bottom: 32px;
}

.logo {
  height: 32px;
  opacity: 0.9;
}

.conteudo-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.headline {
  font-family: var(--estilo); /* Alexandria */
  font-size: 32px;
  color: var(--cor-branco);
  text-align: center;
  margin: 0 0 24px 0;
  line-height: 1.3;
}

.headline .destaque {
  color: var(--cor-azul);
  text-shadow: 0 0 20px rgba(20, 203, 240, 0.3);
}

.divisor {
  width: 80px;
  height: 4px;
  background: var(--degrade);
  border-radius: 2px;
  margin-bottom: 32px;
  opacity: 0.8;
}

/* Video Wrapper para Aspect Ratio 16:9 */
.video-wrapper {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
  background: #000;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 32px;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.area-botao {
  width: 100%;
  max-width: 400px;
  height: 64px; /* Reserva espaço para evitar pulo de layout */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
}

.botao-acao {
  width: 100%;
  color: var(--cor-branco);
  border: none;
  padding: 18px 24px;
  border-radius: 20px;
  font-family: var(--bold);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Estilos Botão Azul (Restaurados) */
.botao-acao.azul {
  background: var(--cor-azul);
  box-shadow: 0 8px 20px -4px rgba(20, 203, 240, 0.4);
  animation: pulse-azul 2s infinite;
}

.botao-acao.azul:hover {
  background: #0fbbdc;
  transform: translateY(-2px);
  box-shadow: 0 12px 28px -6px rgba(20, 203, 240, 0.6);
  animation: none;
}

.loading-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  animation: pulse-texto 2s infinite;
  text-align: center;
}

.footer-seguranca {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  margin-top: 8px;
}

/* Animações */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes pulse-azul {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(20, 203, 240, 0.4); }
  70% { transform: scale(1.02); box-shadow: 0 0 0 10px rgba(20, 203, 240, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(20, 203, 240, 0); }
}

@keyframes pulse-texto {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 0.7; }
}

/* Transição Vue para o botão */
.fade-slide-enter-active {
  transition: all 0.8s ease-out;
}
.fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-slide-enter-from {
  transform: translateY(20px);
  opacity: 0;
}
.fade-slide-enter-to {
  transform: translateY(0);
  opacity: 1;
}

/* 
  Mobile Optimization 
  Ajustes finos para melhor experiência em telas pequenas
*/
@media (max-width: 600px) {
  .conteudo-container {
    padding: 16px; /* Menos padding lateral na tela */
    align-items: flex-start; /* Alinha ao topo para evitar cortes em telas pequenas landscape */
    padding-top: 32px;
  }

  .conteudo-card {
    padding: 0; /* Remove padding do card para aproveitar largura total */
    border: none;
    background: transparent;
    box-shadow: none;
    backdrop-filter: none;
  }
  
  .headline {
    font-size: 26px; /* Fonte levemente menor */
    line-height: 1.2;
    margin-bottom: 20px;
    padding: 0 16px; /* Padding apenas no texto */
  }

  .headline .destaque {
    display: block; /* Quebra linha forçada para destaque */
    margin-top: 4px;
  }

  .video-wrapper {
    width: 100vw; /* Vídeo ocupa largura total da tela */
    margin-left: -16px; /* Compensa o padding do container pai */
    margin-right: -16px;
    border-radius: 0; /* Remove bordas arredondadas no mobile full width */
    border-left: none;
    border-right: none;
    margin-bottom: 24px;
  }

  .divisor {
    margin-bottom: 24px;
  }

  .area-botao {
    padding: 0 16px;
    margin-bottom: 16px;
  }

  .botao-acao {
    padding: 16px 20px;
    font-size: 15px;
  }

  .footer-seguranca {
    margin-top: 0;
    margin-bottom: 32px;
  }
}
</style>